import { MdOutlineStarBorder } from 'react-icons/md';
import { Resources } from '../../resource';
import { ResourceOptions } from 'react-admin';

export { default as list } from './List';
export const name = Resources.predictionFeaturedMarkets;
export const icon = MdOutlineStarBorder;
export const options: ResourceOptions = {
  label: 'resource.predictionFeaturedMarkets',
};
